import type { CookieCategoryConfig } from '../types/cookies.types';

/** Default category definitions shown in the preferences modal (Romanian). */
export const COOKIE_CATEGORIES: CookieCategoryConfig[] = [
  {
    id: 'necessary',
    label: 'Strict necesare',
    description:
      'Esențiale pentru funcționarea site-ului: sesiune, securitate CSRF, preferințe de consimțământ. Nu pot fi dezactivate.',
    required: true,
    cookies: [
      {
        name: 'session',
        provider: 'INITWIN',
        purpose: 'Menține sesiunea utilizatorului autentificat',
        expiry: 'Sesiune',
      },
      {
        name: 'csrf_token',
        provider: 'INITWIN',
        purpose: 'Protecție împotriva atacurilor cross-site',
        expiry: 'Sesiune',
      },
      {
        name: 'cookie_consent',
        provider: 'INITWIN',
        purpose: 'Stochează preferințele tale privind cookie-urile',
        expiry: '12 luni',
      },
    ],
  },
  {
    id: 'analytics',
    label: 'Analiză și performanță',
    description:
      'Ne ajută să înțelegem cum este folosit site-ul (pagini vizitate, surse de trafic) pentru îmbunătățiri.',
    required: false,
    cookies: [
      {
        name: '_ga',
        provider: 'Google Analytics',
        purpose: 'Distinge utilizatorii unici',
        expiry: '2 ani',
      },
      {
        name: '_ga_*',
        provider: 'Google Analytics',
        purpose: 'Păstrează starea sesiunii pentru analiză',
        expiry: '2 ani',
      },
    ],
  },
  {
    id: 'marketing',
    label: 'Marketing',
    description:
      'Permite măsurarea campaniilor și afișarea de conținut relevant pe alte platforme.',
    required: false,
    cookies: [
      {
        name: '_fbp',
        provider: 'Meta (Facebook)',
        purpose: 'Urmărire conversii și audiențe publicitare',
        expiry: '3 luni',
      },
    ],
  },
  {
    id: 'preferences',
    label: 'Preferințe',
    description:
      'Rețin setările tale (ex. limbă, temă) pentru o experiență personalizată.',
    required: false,
    cookies: [
      {
        name: 'ui_prefs',
        provider: 'INITWIN',
        purpose: 'Salvează preferințe de interfață',
        expiry: '12 luni',
      },
    ],
  },
];
